.ar{flex-wrap:wrap;}